import { createSlice, createSelector } from "@reduxjs/toolkit";
import { appVersion } from "../../common/utils";

const initialState = {
  newAppVersion: null,
  needRestart: false,
  error: null,
};

const appUpdateSlice = createSlice({
  name: "appUpdate",
  initialState,
  reducers: {
    setNewAppVersion: (state, action) => {
      const currentVersion = state.newAppVersion;
      const newVersion = action.payload;

      // le user reçoit la notif de maj de firestore pendant qu'il est sur l'app
      // on lui indique qu'il faut restart
      if (currentVersion && currentVersion !== newVersion) {
        state.needRestart = true;
      }

      state.newAppVersion = newVersion;
      state.error = null;
    },
    setAppUpdateError: (state, action) => {
      state.error = action.payload;
    },
  },
  // rien en cas de logout
});

export default appUpdateSlice.reducer;

export const appUpdateActions = appUpdateSlice.actions;

export const selectNewAppVersion = (state) => state.appUpdate.newAppVersion;

export const selectIsNewAppVersion = createSelector(
  selectNewAppVersion,
  (newAppVersion) => newAppVersion && newAppVersion !== appVersion
);

export const selectIsNeedRestart = (state) => state.appUpdate.needRestart;

export const selectIsAppUpdateError = createSelector(
  (state) => state.appUpdate.error,
  (appUpdateError) => appUpdateError !== null
);
